
import HandleTokenAdvanced from "./HandleTokenAdvanced";
import {useParams} from "react-router-dom";

export default function HandleSentenceAdvanced({sentence, annotation, lemma, UD, trans}) {

    let params = useParams();

    let transParam = 'null';
if (trans === 'cyr') {
    transParam = '1';
}

const source = sentence[1]
const tokens = sentence[2]
const lemmata = sentence[3]
const annotations = sentence[4]
const translation = sentence[5]
const UDs = sentence[6]
const targetIndex = sentence[7]
const sentID = sentence[10]

let link = `https://www.punco.uzh.ch/output.php?chapter=${source.slice(0,3)}&cyr=${transParam}`;
let  link2 = `https://punco.uzh.ch/syntax.php?chapter=${source.slice(0,3)}&cyr=${transParam}&sent_id=${sentID}`;


if (params.corpus === 'petka') {
    link = `https://www.punco.uzh.ch/output.php?corpus=petka&chapter=${source.slice(0,3)}&cyr=${transParam}`;
    link2 = `https://punco.uzh.ch/syntax.php?corpus=petka&chapter=${source.slice(0,3)}&cyr=${transParam}&sent_id=${sentID}`;

}

return (

    <> 
    {tokens.map((token, index) => (<span key={index}><HandleTokenAdvanced
     token={token}
      lemma={lemmata[index]} 
      annotation={annotations[index]}
      UD = {UDs[index]}
      index = {index}
      targetIndex = {targetIndex}

      /> </span>))}

    <br/>
        <i>{translation}</i>  <br/>
            <a href={link}
             target='_blank' rel="noreferrer" style={{textDecoration: 'None', color: '#2a86ad'}}><i>({source})</i></a><br/>
         <a href={link2}
             target='_blank'  rel="noreferrer" style={{textDecoration: 'None', color: '#2a86ad'}}><i>Sentence view</i></a>
       
    </>
)


}

// `https://www.punco.uzh.ch/output.php?chapter=${source.slice(0,3)}&cyr=null`